export default {
  namespaced: true,
  pisos: {
    title: "Floors",
    unit_id: "Facility",
    name: "Name",
    floor_number: "Floor number",
    headcount: "Maximum capacity",
    headcount_table: "Occupancy",
    is_occupied: "Is it occupied?",
    active_inactive: "Active/Inactive",
    active: "Active",
    inactive: "Inactive",
    rems: "REMS",
    sirh: "SIRH",
    sector: "Sector",
  },
};
